module.exports = __webpack_public_path__ + "img/r6-ur3.930badfb.jpg";